/* eslint-disable */
// ####################################+################################################
// ################# THIS IS GENERATED FILE DO NOT TOUCH!!!!!!!!!!!!####################
// ####################################-################################################
import type * as Types from '../packlets/generated'

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
import { DiscordInterestBaseFragmentFragmentDoc } from './discord.generated'
export type UserBaseFragmentFragment = {
  __typename?: 'User'
  id: string
  isOnboardingCompleted: boolean
  isTutorialCompleted: boolean
  createdAt: string
  updatedAt: string
  name?: string | null | undefined
  email?: string | null | undefined
  isAdmin: boolean
  discordServer?: Types.SecuredServer | null | undefined
  discordCountryCode?: Types.CountryCode | null | undefined
  countryCode?: Types.CountryCode | null | undefined
  currency?: Types.CurrencyCode | null | undefined
  type: Types.UserType
  totalRafflesEntered: number
  subscriptionType?: Types.UserSubscriptionType | null | undefined
  userSubscriptionProductType: Types.UserSubscriptionProductType
  discordUser?:
    | {
        __typename?: 'DiscordUser'
        id: string
        username: string
        email: string
        avatar: string
        isVerified: boolean
        createdAt: string
        updatedAt: string
        scope: string
        accessTokenExpiresAt?: string | null | undefined
      }
    | null
    | undefined
  discordInterests: Array<{
    __typename?: 'DiscordInterest'
    type: Types.DiscordInterestType
    name: string
    description?: string | null | undefined
  }>
  metadata: {
    __typename?: 'UserMetadata'
    experienceLevel?: Types.ExperienceLevel | null | undefined
    userBehaviour?: Types.UserBehaviour | null | undefined
    dateOfBirth?: string | null | undefined
  }
}

export type DeviceFragmentFragment = {
  __typename?: 'Device'
  id: string
  deviceType: Types.DeviceType
  token: string
}

export type SessionBaseFragmentFragment = {
  __typename?: 'Session'
  token: string
  expiresAt: string
  isActive: boolean
  subscriptionProductType: Types.UserSubscriptionProductType
}

export type DiscordSessionBaseFragmentFragment = {
  __typename?: 'DiscordSession'
  token: string
  expiresAt: string
  isActive: boolean
}

export type DiscordUserBaseFragmentFragment = {
  __typename?: 'DiscordUser'
  id: string
  username: string
  email: string
  avatar: string
  isVerified: boolean
  createdAt: string
  updatedAt: string
  scope: string
  accessTokenExpiresAt?: string | null | undefined
}

export type GetSelfQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetSelfQuery = {
  __typename?: 'Query'
  getSelf: {
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }
}

export type GetUserDiscordRolesQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']
}>

export type GetUserDiscordRolesQuery = {
  __typename?: 'Query'
  getUserDiscordRoles: Array<string>
}

export type UpdateUserMutationVariables = Types.Exact<{
  id: Types.Scalars['String']
  input: Types.UpdateUserInput
}>

export type UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }
}

export type AttachDeviceToSessionMutationVariables = Types.Exact<{
  input: Types.CreateDeviceInput
}>

export type AttachDeviceToSessionMutation = {
  __typename?: 'Mutation'
  attachDeviceToSession: {
    __typename?: 'Device'
    id: string
    deviceType: Types.DeviceType
    token: string
  }
}

export type UpdateUserDiscordCountryMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']
  countryCode: Types.Scalars['String']
}>

export type UpdateUserDiscordCountryMutation = {
  __typename?: 'Mutation'
  updateUserDiscordCountry: {
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }
}

export type UpdateUserDiscordInterestsMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']
  input: Types.UpdateUserDiscordInterestsInput
}>

export type UpdateUserDiscordInterestsMutation = {
  __typename?: 'Mutation'
  updateUserDiscordInterests: {
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }
}

export type UpdateUserMetadataMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']
  input: Types.UpdateUserMetadataInput
}>

export type UpdateUserMetadataMutation = {
  __typename?: 'Mutation'
  updateUserMetadata: {
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }
}

export type SetExperienceLevelMutationVariables = Types.Exact<{
  experienceLevel: Types.ExperienceLevel
  userId: Types.Scalars['String']
}>

export type SetExperienceLevelMutation = {
  __typename?: 'Mutation'
  setExperienceLevel: {
    __typename?: 'User'
    id: string
    isOnboardingCompleted: boolean
    isTutorialCompleted: boolean
    createdAt: string
    updatedAt: string
    name?: string | null | undefined
    email?: string | null | undefined
    isAdmin: boolean
    discordServer?: Types.SecuredServer | null | undefined
    discordCountryCode?: Types.CountryCode | null | undefined
    countryCode?: Types.CountryCode | null | undefined
    currency?: Types.CurrencyCode | null | undefined
    type: Types.UserType
    totalRafflesEntered: number
    subscriptionType?: Types.UserSubscriptionType | null | undefined
    userSubscriptionProductType: Types.UserSubscriptionProductType
    discordUser?:
      | {
          __typename?: 'DiscordUser'
          id: string
          username: string
          email: string
          avatar: string
          isVerified: boolean
          createdAt: string
          updatedAt: string
          scope: string
          accessTokenExpiresAt?: string | null | undefined
        }
      | null
      | undefined
    discordInterests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
    metadata: {
      __typename?: 'UserMetadata'
      experienceLevel?: Types.ExperienceLevel | null | undefined
      userBehaviour?: Types.UserBehaviour | null | undefined
      dateOfBirth?: string | null | undefined
    }
  }
}

export const DiscordUserBaseFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscordUserBaseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DiscordUser' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessTokenExpiresAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscordUserBaseFragmentFragment, unknown>
export const UserBaseFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBaseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isOnboardingCompleted' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isTutorialCompleted' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordServer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discordCountryCode' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discordUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DiscordUserBaseFragment' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRafflesEntered' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discordInterests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DiscordInterestBaseFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'experienceLevel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userBehaviour' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSubscriptionProductType' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserBaseFragmentFragment, unknown>
export const DeviceFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Device' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeviceFragmentFragment, unknown>
export const SessionBaseFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SessionBaseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Session' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptionProductType' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SessionBaseFragmentFragment, unknown>
export const DiscordSessionBaseFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscordSessionBaseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DiscordSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscordSessionBaseFragmentFragment, unknown>
export const GetSelfDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSelf' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSelf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserBaseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetSelfQuery, GetSelfQueryVariables>
export const GetUserDiscordRolesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserDiscordRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserDiscordRoles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserDiscordRolesQuery,
  GetUserDiscordRolesQueryVariables
>
export const UpdateUserDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserBaseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>
export const AttachDeviceToSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AttachDeviceToSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDeviceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachDeviceToSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DeviceFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...DeviceFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AttachDeviceToSessionMutation,
  AttachDeviceToSessionMutationVariables
>
export const UpdateUserDiscordCountryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserDiscordCountry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countryCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserDiscordCountry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countryCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserBaseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateUserDiscordCountryMutation,
  UpdateUserDiscordCountryMutationVariables
>
export const UpdateUserDiscordInterestsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserDiscordInterests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserDiscordInterestsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserDiscordInterests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserBaseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateUserDiscordInterestsMutation,
  UpdateUserDiscordInterestsMutationVariables
>
export const UpdateUserMetadataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserMetadataInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserBaseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateUserMetadataMutation,
  UpdateUserMetadataMutationVariables
>
export const SetExperienceLevelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setExperienceLevel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'experienceLevel' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ExperienceLevel' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setExperienceLevel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'experienceLevel' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'experienceLevel' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserBaseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserBaseFragmentFragmentDoc.definitions,
    ...DiscordUserBaseFragmentFragmentDoc.definitions,
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SetExperienceLevelMutation,
  SetExperienceLevelMutationVariables
>
